/**
 * Extreme Outfitters — Globo step guidance
 * Pulses the next field or option group after a selection.
 */
(function () {
  var PULSE_CLASS = 'eo-gpo-guide-pulse';
  var ROOT_SELECTOR = '.gpo-app';
  var GROUP_SELECTOR = '.gpo-group[data-element-id]';
  var FIELD_SELECTOR = '.gpo-element[data-element-id]';
  var GUIDE_DELAY_MS = 200;

  function isGroupVisible(group) {
    if (!group) return false;
    if (group.classList.contains('eo-gpo-group--empty')) return false;
    var style = window.getComputedStyle(group);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return group.offsetParent !== null || style.display === 'block';
  }

  function controlIsVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.offsetHeight > 4;
  }

  function fieldIsGloboShown(field) {
    if (!field || field.dataset.hasClo === undefined) return null;
    return field.dataset.cloDisplay === 'hide';
  }

  function groupIsGloboShown(group) {
    if (!group || group.dataset.hasClo === undefined) return null;
    return group.dataset.cloDisplay === 'hide';
  }

  function groupHasVisibleControls(group) {
    if (group.querySelector('.gpo-dropdown .dropdown-button')) {
      return controlIsVisible(group.querySelector('.gpo-dropdown .dropdown-button'));
    }

    if (group.querySelector('.gpo-switch label')) {
      return controlIsVisible(group.querySelector('.gpo-switch label'));
    }

    var optionItems = group.querySelectorAll(
      '.gpo-ov-wrapper > .gpo-swatches, .gpo-ov-wrapper > .gpo-choicelist, .gpo-ov-wrapper > .gpo-radio'
    );

    for (var i = 0; i < optionItems.length; i++) {
      if (controlIsVisible(optionItems[i])) return true;
    }

    return false;
  }

  function groupShouldHideAsEmpty(group) {
    var groupShown = groupIsGloboShown(group);
    if (groupShown === true) return false;
    if (groupShown === false) return true;

    var fields = group.querySelectorAll(FIELD_SELECTOR);
    var hasNonCloField = false;

    for (var i = 0; i < fields.length; i++) {
      var fieldShown = fieldIsGloboShown(fields[i]);
      if (fieldShown === true) return false;
      if (fieldShown === null) hasNonCloField = true;
    }

    if (hasNonCloField) {
      return !groupHasVisibleControls(group);
    }

    if (fields.length > 0) return true;

    return !groupHasVisibleControls(group);
  }

  function walkGpoElements(elements, callback) {
    if (!elements || !elements.length) return;

    elements.forEach(function (element) {
      callback(element);
      if (element.elements) walkGpoElements(element.elements, callback);
    });
  }

  function syncImageSwatches(app) {
    var configs = window.GPOConfigs && window.GPOConfigs.options;
    if (!configs) return;

    var fileUrl = window.GPOConfigs.fileUrl || '';

    Object.keys(configs).forEach(function (optionId) {
      var optionSet = configs[optionId];
      if (!optionSet || !optionSet.elements) return;

      walkGpoElements(optionSet.elements, function (element) {
        if (element.type !== 'color-swatches' || element.swatch_style !== 'image') return;

        var field = app.querySelector('[data-element-id="' + element.id + '"]');
        if (!field) return;

        (element.option_values || []).forEach(function (optionValue) {
          if (!optionValue.asset_name) return;

          var inputId = element.id + '_' + (optionValue.id + 1);
          var input = field.querySelector('#' + inputId);
          if (!input) return;

          var swatchTop = input.closest('.gpo-ov-item');
          swatchTop = swatchTop && swatchTop.querySelector('.swatch-top');
          if (!swatchTop) return;

          var imageUrl = fileUrl + optionValue.asset_name;
          swatchTop.style.backgroundImage = 'url("' + imageUrl + '")';
          swatchTop.style.backgroundSize = 'cover';
          swatchTop.style.backgroundPosition = 'center';
          swatchTop.style.backgroundRepeat = 'no-repeat';
          swatchTop.setAttribute('data-eo-swatch-image', 'true');
        });
      });
    });
  }

  function syncEmptyGroups(app) {
    app.querySelectorAll(GROUP_SELECTOR).forEach(function (group) {
      var style = window.getComputedStyle(group);

      // Globo conditionally hides the whole group — do not fight that.
      // Skip only when display:none is from Globo, not from our empty-state class.
      if (style.display === 'none' && !group.classList.contains('eo-gpo-group--empty')) {
        group.classList.remove('eo-gpo-group--empty');
        return;
      }

      group.classList.toggle('eo-gpo-group--empty', groupShouldHideAsEmpty(group));
    });
  }

  function isFieldVisible(field) {
    if (!field) return false;

    var style = window.getComputedStyle(field);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    var group = getGroupForElement(field);
    if (!group || !isGroupVisible(group)) return false;

    var node = field.parentElement;
    while (node && node !== group) {
      if (window.getComputedStyle(node).display === 'none') return false;
      node = node.parentElement;
    }

    return true;
  }

  function getVisibleGroups(app) {
    return Array.prototype.slice
      .call(app.querySelectorAll(GROUP_SELECTOR))
      .filter(isGroupVisible);
  }

  function getGroupForElement(el) {
    return el.closest(GROUP_SELECTOR);
  }

  function getFieldForElement(el) {
    return el.closest(FIELD_SELECTOR);
  }

  function getGroupFields(group) {
    return Array.prototype.slice.call(
      group.querySelectorAll('.gpo-group__childs > ' + FIELD_SELECTOR)
    );
  }

  function getVisibleFields(group) {
    return getGroupFields(group).filter(isFieldVisible);
  }

  function clearPulse(app) {
    app.querySelectorAll('.' + PULSE_CLASS).forEach(function (el) {
      el.classList.remove(PULSE_CLASS);
      el.removeAttribute('data-eo-gpo-guide');
    });
  }

  function getFocusTarget(container) {
    var field = container.matches && container.matches(FIELD_SELECTOR)
      ? container
      : getFieldForElement(container) || container;

    if (field && field.querySelector && field.querySelector('.gpo-switch')) {
      return field.querySelector('.gpo-label') || field;
    }

    return (
      (field && field.querySelector && field.querySelector('.gpo-dropdown .dropdown-button')) ||
      (field && field.querySelector && field.querySelector('.gpo-switch input[type="checkbox"]')) ||
      (field && field.querySelector && field.querySelector('.gpo-swatches.buttons input + label')) ||
      (field && field.querySelector && field.querySelector('.gpo-swatches.color-swatches input + label')) ||
      (field && field.querySelector && field.querySelector('.gpo-swatches.image-swatches input + label')) ||
      (field && field.querySelector && field.querySelector('.gpo-radio input + label')) ||
      (field && field.querySelector && field.querySelector('.gpo-choicelist input + label')) ||
      container
    );
  }

  function focusTarget(target) {
    if (!target) return;

    if (target.classList && target.classList.contains('dropdown-button')) {
      target.setAttribute('tabindex', '-1');
    } else if (target.setAttribute) {
      target.setAttribute('tabindex', '-1');
    }

    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      /* noop */
    }
  }

  function pulseElement(target, scrollTarget) {
    if (!target) return;

    target.classList.add(PULSE_CLASS);
    target.setAttribute('data-eo-gpo-guide', 'true');
    target.setAttribute('tabindex', '-1');

    var scrollEl = scrollTarget || target;

    window.requestAnimationFrame(function () {
      scrollEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () {
        focusTarget(getFocusTarget(target));
      }, 280);
    });
  }

  function pulseStepTarget(field) {
    if (!field) return;

    var group = getGroupForElement(field);
    if (!group) {
      pulseElement(field);
      return;
    }

    var visibleFields = getVisibleFields(group);

    if (visibleFields.length > 1) {
      pulseElement(field);
      return;
    }

    var wrapper = group.querySelector('.gpo-group__wrapper');
    if (wrapper) {
      pulseElement(wrapper);
      return;
    }

    pulseElement(field);
  }

  function getFirstValidationErrorField(app) {
    var fields = app.querySelectorAll(FIELD_SELECTOR + '.has-error');

    for (var i = 0; i < fields.length; i++) {
      if (isFieldVisible(fields[i])) return fields[i];
    }

    return null;
  }

  function pulseValidationError(app) {
    window.clearTimeout(app._eoGpoValidationTimer);
    app._eoGpoValidationTimer = window.setTimeout(function () {
      syncEmptyGroups(app);

      var field = getFirstValidationErrorField(app);
      if (!field) return;

      clearPulse(app);
      pulseStepTarget(field);
    }, 300);
  }

  function guideToNextStep(app, fromField) {
    clearPulse(app);

    if (!fromField) return;

    var group = getGroupForElement(fromField);
    if (!group) return;

    var visibleFields = getVisibleFields(group);
    var fieldIndex = visibleFields.indexOf(fromField);
    var nextField = fieldIndex >= 0 ? visibleFields[fieldIndex + 1] : null;

    if (nextField) {
      pulseStepTarget(nextField);
      return;
    }

    var visibleGroups = getVisibleGroups(app);
    var groupIndex = visibleGroups.indexOf(group);
    var nextGroup = groupIndex >= 0 ? visibleGroups[groupIndex + 1] : null;
    if (!nextGroup) return;

    var nextGroupFields = getVisibleFields(nextGroup);

    if (nextGroupFields.length > 1) {
      pulseStepTarget(nextGroupFields[0]);
      return;
    }

    var wrapper = nextGroup.querySelector('.gpo-group__wrapper');
    if (wrapper) {
      pulseElement(wrapper);
    }
  }

  function scheduleGuide(app, fromField) {
    window.clearTimeout(app._eoGpoGuideTimer);
    app._eoGpoGuideTimer = window.setTimeout(function () {
      guideToNextStep(app, fromField);
    }, GUIDE_DELAY_MS);
  }

  function bindValidationPulse(app) {
    if (!app || app.dataset.eoGpoValidationBound) return;

    var productForm = app.closest('form');
    if (!productForm) return;

    app.dataset.eoGpoValidationBound = 'true';

    productForm.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(
          '[data-add-to-cart], .add-to-cart, button[name="add"]'
        );
        if (!button || button.disabled) return;
        pulseValidationError(app);
      },
      true
    );
  }

  function bindApp(app) {
    if (!app || app.dataset.eoGpoGuideBound) return;
    app.dataset.eoGpoGuideBound = 'true';

    bindValidationPulse(app);

    app.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !app.contains(target)) return;

      var field = getFieldForElement(target);
      if (!field) return;

      var pulsing = app.querySelector('.' + PULSE_CLASS);
      if (pulsing) {
        pulsing.classList.remove(PULSE_CLASS);
        pulsing.removeAttribute('data-eo-gpo-guide');
      }

      scheduleGuide(app, field);
      syncEmptyGroups(app);
      syncImageSwatches(app);
    });
  }

  function init() {
    var app = document.querySelector(ROOT_SELECTOR);
    if (!app) return;
    bindApp(app);
    syncEmptyGroups(app);
    syncImageSwatches(app);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var mountObserver = new MutationObserver(function () {
    init();
    var app = document.querySelector(ROOT_SELECTOR);
    if (!app) return;
    syncEmptyGroups(app);
    syncImageSwatches(app);
  });

  mountObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
